import { FC } from "react"
import { DebouncedInput } from "./DebouncedInput"

interface SearchProps {
  value: string
  onChange: (value: string) => void
}

export const Search: FC<SearchProps> = ({ value, onChange }) => {
  return (
    <div>
      <label htmlFor="search" className="sr-only">
        Search
      </label>
      <DebouncedInput
        name="search"
        type="search"
        className="input mt-0"
        placeholder="Search"
        value={value}
        onChange={(value) => onChange(value)}
      />
    </div>
  )
}
